import React from 'react'
import PropTypes from 'prop-types'
import ReactPlayer from 'react-player'

import { MEDIA_TYPE_VIDEO } from 'src/lib/media'
import { Box } from '@chatterbug/aaron'
import { Modal } from '@chatterbug/aaron/modal'

import { customModalStyle } from '../utils'

const MediaModal = ({
  type = MEDIA_TYPE_VIDEO,
  isOpen,
  title,
  sourceUrl,
  width = 640,
  height = 360,
  onHide = () => {},
  ...rest
}) => {
  return (
    <Modal
      isOpen={isOpen}
      title={title}
      onRequestClose={onHide}
      style={customModalStyle}
    >
      <Box
        minWidth={{ _: '65vw', tabletWide: 0 }}
        width={{ _: '100%', tabletWide: width }}
        pt={{ _: `${Math.round((height * 100) / width)}%`, tabletWide: height }} // to keep the aspect ratio
        sx={{
          position: 'relative',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        >
          {isOpen && type === MEDIA_TYPE_VIDEO && (
            <ReactPlayer
              controls
              url={sourceUrl}
              width="100%"
              height="100%"
              {...rest}
            />
          )}
        </Box>
      </Box>
    </Modal>
  )
}

MediaModal.propTypes = {
  type: PropTypes.oneOf([MEDIA_TYPE_VIDEO]),
  isOpen: PropTypes.bool,
  title: PropTypes.string,
  sourceUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onHide: PropTypes.func,
}

export default MediaModal
